// extracted by mini-css-extract-plugin
export var divider = "_l0-0";
export var systemMessage = "_l0-1";